import React from 'react';

import { Box } from '@mui/material';

interface Props {
  navigation: React.ReactNode;
  children: React.ReactNode;
}

export default function SectionNavigationLayout({ navigation, children }: Props) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '240px minmax(0, 1fr)' },
        gap: 3,
        alignItems: 'start',
      }}
    >
      {navigation}
      <Box sx={{ minWidth: 0 }}>{children}</Box>
    </Box>
  );
}
